module.exports = __webpack_public_path__ + "assets/img/aboutUS-module6-5.a0444486.jpg";